import React, { useState, useEffect } from "react";
import "../../entrydoor.css";
import "./GentekColor.css";

const GentekColor = ({ controlId, value = {}, onChange, label = "Gentek Color", color = null, dividers = null, disabled = false }) => {
  const [selectedGentekColor, setSelectedGentekColor] = useState(value);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isControlVisible, setIsControlVisible] = useState(false);

  const options = [
    { value: "#000000", label: "Black 525", color: "#000000" },
    { value: "#D2B48C", label: "Almond 532", color: "#D2B48C" },
    { value: "#FFBF00", label: "Amber", color: "#FFBF00" },
    { value: "#5C4033", label: "Antique Brown", color: "#5C4033" },
    { value: "#F5E1C0", label: "Antique Ivory 533", color: "#F5E1C0" },
    { value: "#E10600", label: "Bright Red 322", color: "#E10600" },
    { value: "#FFFFFF", label: "Bright White", color: "#FFFFFF" },
    { value: "#8B4513", label: "Brownstone 571", color: "#8B4513" },
    { value: "#D2B48C", label: "Canyon Clay 510", color: "#D2B48C" },
    { value: "#E6CBA8", label: "Cashmere 514", color: "#E6CBA8" },
    { value: "#8B4513", label: "Chestnut Brown 554", color: "#8B4513" },
    { value: "#4682B4", label: "Coastal Blue 5P9", color: "#4682B4" },
    { value: "#654321", label: "Commercial Brown 562", color: "#654321" },
    { value: "#B87333", label: "Copper 575", color: "#B87333" },
    { value: "#FFFDD0", label: "Cream 492", color: "#FFFDD0" },
    { value: "#7F8C8D", label: "Dark Drift 557", color: "#7F8C8D" },
    { value: "#757575", label: "Dover Gray 536", color: "#757575" },
    { value: "#3C2F2F", label: "Espresso 5P3", color: "#3C2F2F" },
    { value: "#228B22", label: "Forest Green 556", color: "#228B22" },
    { value: "#F8F8FF", label: "Glacier White", color: "#F8F8FF" },
    { value: "#474747", label: "Graphite 5P5", color: "#474747" },
    { value: "#D8B04A", label: "Harvest Wheat 543", color: "#D8B04A" },
    { value: "#F0F8FF", label: "Ice White", color: "#F0F8FF" },
    { value: "#383838", label: "Iron Ore 5P6", color: "#383838" },
    { value: "#228B22", label: "Ivy Green 522", color: "#228B22" },
    { value: "#457E66", label: "Juniper Grove 580", color: "#457E66" },
    { value: "#F5E1A4", label: "Lambeth Beige 501", color: "#F5E1A4" },
    { value: "#FBEC5D", label: "Maize 502", color: "#FBEC5D" },
    { value: "#003366", label: "Midnight Surf 509", color: "#003366" },
    { value: "#B0E0E6", label: "Mist Blue 537", color: "#B0E0E6" },
    { value: "#556B2F", label: "Moonlit Moss 513", color: "#556B2F" },
    { value: "#5B4329", label: "Mountain Arbor 5P1", color: "#5B4329" },
    { value: "#D2B48C", label: "Nutmeg 568", color: "#D2B48C" },
    { value: "#2F4F4F", label: "Old World Blue 542", color: "#2F4F4F" },
    { value: "#F5F5DC", label: "Pearl 534", color: "#F5F5DC" },
    { value: "#C2B280", label: "Pebble 559", color: "#C2B280" },
    { value: "#E3E4E0", label: "Rainware White 430", color: "#E3E4E0" },
    { value: "#4363D8", label: "Rockwell Blue", color: "#4363D8" },
    { value: "#4B3F30", label: "Sable 547", color: "#4B3F30" },
    { value: "#8B4513", label: "Saddle Brown 569", color: "#8B4513" },
    { value: "#9C9C7B", label: "Sage 517", color: "#9C9C7B" },
    { value: "#E9D4B7", label: "Sandalwood 508", color: "#E9D4B7" },
    { value: "#D8B971", label: "Sandstone 540", color: "#D8B971" },
    { value: "#708090", label: "Slate 523", color: "#708090" },
    { value: "#5C5A53", label: "Smoked Timber 5C7", color: "#5C5A53" },
    { value: "#FFFFFF", label: "Snow White", color: "#FFFFFF" },
    { value: "#7B7D7D", label: "Storm 570", color: "#7B7D7D" },
    { value: "#D2B48C", label: "Tan 507", color: "#D2B48C" },
    { value: "#C80815", label: "Venetian Red 539", color: "#C80815" },
    { value: "#5A79B4", label: "Wedgewood Blue 535", color: "#5A79B4" },
    { value: "#D4B483", label: "Wicker 538", color: "#D4B483" },
    { value: "#6E665B", label: "Windswept Smoke 506", color: "#6E665B" }
  ];


  const handleSelect = (option) => {
    setSelectedGentekColor(option);
    onChange(option); // Return the full { value, label } object
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev);
  };

  const handleBlur = () => {
    setTimeout(() => setIsDropdownOpen(false), 100);
  };

  useEffect(() => {
    if (color === 'Gentek') setIsControlVisible(true);
    else setIsControlVisible(false);

    if (dividers === 'None') setIsControlVisible(false);
  }, [color, dividers]);

  useEffect(() => {
    if (value?.value && value?.label) {
      setSelectedGentekColor(value);
    }
  }, [value]);

  return (
    <div className="a-container">
      {isControlVisible && (
        <>
          <label htmlFor="GentekColor">{label}</label>
          <div
            className="custom-dropdown"
            style={{ zIndex: isDropdownOpen ? 1000 + controlId : 1 }}
          >
            <div
              className="dropdown-header"
              onClick={disabled ? null : toggleDropdown}
              onBlur={disabled ? null : handleBlur}
              style={{ cursor: "pointer" }}
              tabIndex={disabled ? -1 : 0}
            >
              <div
                className="color-circle"
                style={{
                  backgroundColor:
                    selectedGentekColor?.value || "transparent",
                }}
              />
              <span>{selectedGentekColor?.label || "Select an option"}</span>
            </div>

            {isDropdownOpen && (
              <div className="dropdown-options">
                {options.map((option, index) => (
                  <div
                    key={`${option.value}-${index}`}
                    className="dropdown-option"
                    onMouseDown={disabled ? null : () => handleSelect(option)}
                  >
                    <div
                      className="color-circle"
                      style={{ backgroundColor: option.color }}
                    />
                    <span>{option.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default GentekColor;
